import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';
import { useAuth } from '../context/AuthContext';
import { loginWithCredentials } from '../services/authService';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');

    try {
      const session = await loginWithCredentials({ email, password });
      login(session);
      navigate(ROUTES.home);
    } catch (requestError) {
      setError('Credenciales inválidas o servicio no disponible');
    }
  }

  return (
    <section className="min-h-screen bg-gradient-to-tr from-yellow-50 via-white to-blue-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="px-6 py-8">
          <h2 className="text-center text-3xl font-extrabold text-blueGray-800 mb-6">Iniciar sesión</h2>
          {error && <p className="text-red-500 text-sm mb-4 text-center">{error}</p>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-blueGray-600 mb-1">Email / Usuario</label>
              <input
                type="text"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="admin"
                className="w-full px-4 py-2 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-blueGray-600 mb-1">Contraseña</label>
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="********"
                className="w-full px-4 py-2 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
              />
            </div>
            <button
              type="submit"
              className="w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg shadow-md transition duration-200"
            >
              Iniciar sesión
            </button>
          </form>
          <div className="flex justify-between text-sm text-blueGray-500 mt-4">
            <span>Acceso para personal autorizado</span>
            <Link to={ROUTES.register} className="hover:underline">Registrar cliente</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
